import {Component, inject} from '@angular/core';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MAT_DIALOG_DATA, MatDialogClose} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {AsyncPipe} from '@angular/common';
import {take} from 'rxjs/operators';
import {triggerHotJarGa} from '../../core/pure-utils/analytics';
export interface SelectedButton<T> {display: string; associatedFunc: (T) => void; triggerAnalytics?: {triggerName: string; eventCategory: string}}
export interface SelectedItemsData<T> {descriptionTitle: string; buttons: SelectedButton<T>[]; items$: Observable<T[]>}

@Component({
  selector: 'app-selected-items-dialog',
  imports: [
    MatButton,
    MatIcon,
    MatIconButton,
    MatDialogClose,
    AsyncPipe
  ],
  templateUrl: './selected-items-dialog.component.html',
  styleUrl: './selected-items-dialog.component.scss'
})
export class SelectedItemsDialogComponent<T> {
  readonly data = inject<SelectedItemsData<T>>(MAT_DIALOG_DATA);
  public triggerAnalytics = triggerHotJarGa;

  onButtonClick(button: SelectedButton<T>) {
    this.data.items$.pipe(take(1)).subscribe((data) => {
      button.associatedFunc(data);
    });
  }
}
